import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Input from 'Components/Input';
import Icon from 'Components/Icon';
import { toast } from 'react-toastify';
import EnvironmentManager from 'Utils/environmentManager';
import ToastTemplate from 'Components/ToastTemplate';
import { Button } from 'antd';
import { updateTribunNickname } from 'Store/actions';
import { useDispatch } from 'react-redux';
import { classnames } from 'Utils/classnames';
import OutsideClickHandler from 'react-outside-click-handler';

const TribunChangeNickName = data => {
  const dispatch = useDispatch();
  const [warningMessageName, setWarningMessageName] = useState(null);
  const [nickname, setNickname] = useState(data.originalNickName?.slice(0, 16) || '');
  const isButtonDisabled = (nickname === data.originalNickName?.slice(0, 16)) || nickname.length < 2;

  const [remainingUsernameChangeLimitTooltip, setRemainingUsernameChangeLimitTooltip] = useState(false);
  const [isInputFocused, setIsInputFocused] = useState(false);

  const messageText = EnvironmentManager.getMessageText({ key: 'tribun_username_update_remaining_attempts' });
  const messageTextArr = messageText.split('%@');

  const [remainingUsernameChangeRight, setRemainingUsernameChangeRight] = useState(data.remainingUsernameChangeLimit);


  const formRow = classnames({
    form__row: true,
    'margin-top-30': !data.getTribunSettings,
    form__row__changeNicknameModal: !data.getTribunSettings,
    'margin-top-10': data.getTribunSettings
  });

  const formRowButton = classnames({
    form__row: true,
    'drawer-bottom-button': !data.getTribunSettings,
    'margin-top-10': data.getTribunSettings
  });

  const hintMessage = classnames({
    'tribun-settings__avatar__image-hint-message__name': true,
    'tribun-settings__avatar__image-hint-message__name__changeNicknameModal': !data.getTribunSettings
  });

  const labelClass = classnames({
    'form-label': true,
    'form-label--active': nickname.length > 0 || isInputFocused
  });

  const onChange = e => {
    if (e.target.value.length < 17) {
      setNickname(e.target.value.replace(/\s/g, ''));
    }
    setWarningMessageName(null);
  };


  const clearInput = () => {
    setNickname('');
    setWarningMessageName(null);
  };

  const handleInputFocus = () => {
    setIsInputFocused(true);
  };

  const handleInputBlur = () => {
    setIsInputFocused(false);
  };

  const openToastSuccessMessage = remainingUsernameChangeRight => {
    const successText = EnvironmentManager.getMessageText({ key: 'tribune_username_dialog_succeed_text' });
    const remaningChangeText = 'Kalan değişiklik hakkın: ' + remainingUsernameChangeRight;
    toast(
      <ToastTemplate type="nicknameUpdate">
        { successText }
        <br/>
        <strong> { remaningChangeText } </strong>
      </ToastTemplate>,
      {
        toastId: 'updateNickNameToast',
        position: 'bottom-center',
        autoClose: 5000
      }
    );
  };

  const onSubmitForm = async e => {
    dispatch(await updateTribunNickname(nickname)).then(res=>{
      if (res?.status?.code === 200) {
        data?.onPrimaryButtonClick && data?.onPrimaryButtonClick();
        setRemainingUsernameChangeRight(res.remainingUsernameChangeRight);
        openToastSuccessMessage(res.remainingUsernameChangeRight);

        if (res?.pendingRequestNickname) {
          data?.onNicknameUpdatePending?.(res.pendingRequestNickname);
        }
      } else if (res?.code === 4004 || res?.code === 4005 || res?.code === 4046) {
        const failText = EnvironmentManager.getMessageText({ key: `${res?.domain}${res?.code}` });
        const genericText = EnvironmentManager.getMessageText({ key: 'tribun_username_update_generic_error_message' });
        setWarningMessageName(failText || genericText);
      } else if (res?.code) {
        const failText = EnvironmentManager.getMessageText({ key: `${res?.domain}${res?.code}` });
        toast(
          <ToastTemplate type="error">
            { failText }
          </ToastTemplate>,
          {
            toastId: 'updateNickNameFailToast',
            autoClose: 5000,
            position: 'bottom-center'
          }
        );
      }
    });
  };

  return  <form className='form'>
    <div className={ formRow }>
      <div className="form-label-with-icon">
        <label htmlFor="nickname" className={ labelClass }>
          Tribün Kullanıcı Adı
        </label>
        
        <span className="remaining-update-info-icon-wrapper">
          <Icon
            iconName={ 'svgInfoGray' }
            className="remaining-update-info-icon"
            onClick={ () =>
              setRemainingUsernameChangeLimitTooltip(!remainingUsernameChangeLimitTooltip)
            }
          />
          
          { remainingUsernameChangeLimitTooltip && (
            <OutsideClickHandler
              onOutsideClick={ () =>
                setRemainingUsernameChangeLimitTooltip(false)
              }
            >
              <div className="remaining-update-tooltip">
                <span className="remaining-highlight">
                  { messageTextArr?.[0] }
                  <span className="remaining-limit">{ remainingUsernameChangeRight }</span>
                </span>
              </div>
            </OutsideClickHandler>
          ) }
        </span>
      </div>
      
      <Input
        id='nickname'
        value={ nickname }
        onChange={ e => onChange(e) }
        clearInput={ e => clearInput(e) }
        onFocus={ handleInputFocus }
        onBlur={ handleInputBlur }
        validateOnBlur
      />
    </div>

    <div className={ hintMessage }>{ warningMessageName }</div>

    { data.tribunKvkkDiv && data.tribunKvkkDiv }

    <div className={ formRowButton }>
      <Button
        className='btn btn--primary btn--block'
        type='submit'
        disabled={ isButtonDisabled }
        onClick={ () => onSubmitForm() }
      >
      Güncelle
      </Button>
    </div>
  </form>;
};

TribunChangeNickName.propTypes = {
  tribunUser: PropTypes.object,
  updateTribunNickname: PropTypes.func
};

export default TribunChangeNickName;
